import { render } from "./CateCard.vue?vue&type=template&id=00245ab3"
import script from "./CateCard.vue?vue&type=script&lang=js"
export * from "./CateCard.vue?vue&type=script&lang=js"
script.render = render

export default script